import type { GetContentType } from '~/types/GetContentType';
import type { IContentPage } from '~~/lib/ContentfulService/generated/contentful';

export const pageToDefaultThemeMap: Record<
  GetContentType<IContentPage>,
  'dark' | 'light'
> = {
  contentPage: 'dark'
};
